export default class WidgetStyle {
  id!: number;
  startWidgetId!: number;
  buttonColor!: string;
  fontColor!: string;
  headerColor!: string;
  linkColor!: string;
  borderColor!: string;
  itineraryButtonColor!: string;
  bookNowButtonColor!: string;
  getQuoteButtonColor!: string;
  brandLogo!: string;
}

export const WidgetStyleDefaults: WidgetStyle = {
  id: 0,
  startWidgetId: 0,
  buttonColor: "",
  fontColor: "",
  headerColor: "",
  linkColor: "",
  borderColor: "",
  itineraryButtonColor: "",
  bookNowButtonColor: "",
  getQuoteButtonColor: "",
  brandLogo: ""
}